// extracted by mini-css-extract-plugin
export default {"wrapper":"mNA74HU8ysiUdHtjW2zF"};